export const handleNavigateToSearchPage = (
  storeType: string,
  searchQuery: string,
  isSearchPageEnabled: boolean,
  imageSearchUrl?: string,
) => {
  const currentHost = window.location.host;
  const currentPath = window.location.pathname;
  const manipulatedSearchQuery = isSearchPageEnabled
    ? '__' + searchQuery.trim() + '__'
    : searchQuery.trim();
  if (storeType === 'salla') {
    const isDevStore = currentPath.includes('/dev-');
    if (isDevStore) {
      const storePath = currentPath.split('/')[1].split('?')[0];
      window.location.href = `/${storePath}/search?q=${encodeURIComponent(
        manipulatedSearchQuery,
      )}&${imageSearchUrl ? `image=${imageSearchUrl}` : ''}`;
    } else {
      if (currentHost === 'salla.sa') {
        const storePath = currentPath.split('/')[1];
        window.location.href = `${
          window.location.origin
        }/${storePath}/search?q=${encodeURIComponent(manipulatedSearchQuery)}&${
          imageSearchUrl ? `image=${imageSearchUrl}` : ''
        }`;
      } else {
        // Handle other domains with language prefixes
        const pathSegments = currentPath.split('/').filter(Boolean);
        const hasLanguagePrefix =
          pathSegments[0] === 'ar' || pathSegments[0] === 'en';
        const languagePrefix = hasLanguagePrefix
          ? `/${pathSegments[0]}`
          : currentHost === 'balsamalula.com'
          ? '/ar'
          : '';
        window.location.href = `${
          window.location.origin
        }${languagePrefix}/search?q=${encodeURIComponent(
          manipulatedSearchQuery,
        )}&${imageSearchUrl ? `image=${imageSearchUrl}` : ''}`;
      }
    }
  } else if (storeType === 'zid') {
    console.log('Current location:', window.location);
    console.log('Search query:', searchQuery);
    const pathSegments = currentPath.split('/').filter(Boolean);
    const hasLanguagePrefix =
      pathSegments[0] === 'ar' || pathSegments[0] === 'en';
    const languagePrefix = hasLanguagePrefix ? `/${pathSegments[0]}` : '';
    const searchPageUrl = `${
      window.location.origin
    }${languagePrefix}/products?search=${encodeURIComponent(
      manipulatedSearchQuery,
    )}&${imageSearchUrl ? `image=${imageSearchUrl}` : ''}`;
    console.log('Search page URL:', searchPageUrl);
    window.location.href = searchPageUrl;
  } else if (storeType === 'woocommerce') {
    const searchPageUrl = `${
      window.location.origin
    }/search/${encodeURIComponent(manipulatedSearchQuery)}&${
      imageSearchUrl ? `image=${imageSearchUrl}` : ''
    }`;
    console.log('Search page URL:', searchPageUrl);
    window.location.href = searchPageUrl;
  }
};
